
import Dummy from "components/Dummy";
import P from "components/P";
import Inline from "layouts/container/Inline";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import closeIcon from "resources/img/puffu/close.png";
import homeBtnIcon from "resources/img/puffu/homebtn.svg";
import leftIcon from "resources/img/puffu/left.png";
import rightIcon from "resources/img/puffu/right.png";
import { useTouchClick } from "shared/hooks/useTouchClick";
import HorizontalCartList from "../cart/HorizontalCartList";
import HorizontalCategories from "../category/HorizontalCategories";
import style from "./HorizontalProductDetail.module.css";
import HorizontalVendingProductDetail from "./HorizontalVendingProductDetail";
import HorizontalVendingProductInfo from "./HorizontalVendingProductInfo";
import HorizontalVendingProductLayout from "./HorizontalVendingProductLayout";
import HorizontalVendingProductReview from "./HorizontalVendingProductReview";
import categorySound from "resources/music/물방울.mp3";
import { useRef } from "react";



function HorizontalProductDetail(props) {
    const audioRef = useRef();
    const {
        viewData,
        selectedCategory,
        handleTouchStart,
        handleTouchEnd,
        onCloseClick,
        handleTabChange,
        setCurrentTab,
        currentTab,
        shoppingProcesses
    } = props;
    const {
        handleTouchStart: detailCloseTouchStart,
        handleTouchEnd: detailCloseTouchEnd,
    } = useTouchClick(() => onCloseClick(selectedCategory), 10);
    const prevButtonTouch = useTouchClick(() => handleTabChange('prev'));
    const nextButtonTouch = useTouchClick(() => handleTabChange('next'));

    const renderTabContent = () => {
        switch (currentTab) {
            case 'info':
                return <HorizontalVendingProductInfo data={viewData.detailProduct} currentTab={currentTab}
                    setCurrentTab={setCurrentTab} />;
            case 'detail':
                return <HorizontalVendingProductDetail data={viewData.detailProduct} currentTab={currentTab}
                    setCurrentTab={setCurrentTab} />;
            // case 'review':
            //     return <HorizontalVendingProductReview data={viewData.detailProduct} currentTab={currentTab}
            //         setCurrentTab={setCurrentTab} />;
            default:
                return null;
        }
    };
    return (
        <HorizontalFlex flexStart>
            <audio ref={audioRef} src={categorySound} preload="auto" />
            <FlexChild width={"100%"}>
                <VerticalFlex>
                    <FlexChild width={"100%"}>
                        <div
                            onPointerDown={handleTouchStart}
                            onPointerUp={handleTouchEnd}
                            style={{ width: "100%", height: "100%", position: "relative", justifyContent: "center", display: "flex" }}
                        >
                            {/* <div className={style.closeBtn} 
                            onPointerDown={detailCloseTouchStart}
                            onPointerUp={detailCloseTouchEnd}>
                                <img src={closeIcon} width={"25px"} style={{ filter: "invert(60%)", position: "relative", right: 0 }} />
                            </div> */}
                            <div
                                onPointerDown={detailCloseTouchStart}
                                onPointerUp={detailCloseTouchEnd}
                                style={{ position: 'absolute', top: '30px', right: "48px", width: '17.5%', padding: "10px 10px" }}>
                                <div

                                    className={style.backBtn}
                                    style={{ height: "53px", backgroundColor: "white", border: "1.5px solid var(--main-color)", borderRadius: "3px" }}
                                >
                                    <Center>
                                        <Inline>
                                            <img src={homeBtnIcon} width={"30px"} />
                                            <Dummy width={"15px"} />
                                            <P color={"var(--main-color)"} weight={900} font={"Pretendard"} size={"1.5vw"}>뒤로가기</P>
                                        </Inline>
                                    </Center>
                                </div>
                            </div>
                            <div style={{ zIndex: 99, gap: "20px", display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'absolute', bottom: '20px', right: "80px", width: '42%' }}>
                                <div
                                    onPointerDown={prevButtonTouch.handleTouchStart}
                                    onPointerUp={prevButtonTouch.handleTouchEnd}
                                    style={{
                                        width: "600px",
                                        height: "44px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        backgroundColor: "var(--point-color)",
                                        border: "white",
                                        color: "#fff",
                                        cursor: "pointer",
                                        borderRadius: '5px',
                                        padding: "0 10px"
                                    }}
                                    className={style.btn}
                                >
                                    <HorizontalFlex>
                                        <FlexChild width={"40%"}>
                                            <img src={leftIcon} width={"10px"} style={{ filter: "invert(50%) brightness(250%)" }} />
                                        </FlexChild>
                                        <FlexChild>
                                            <P font={"Pretendard"} weight={700} size={20} color={"white"}>이전</P>
                                        </FlexChild>
                                    </HorizontalFlex>
                                </div>
                                <div
                                    onPointerDown={nextButtonTouch.handleTouchStart}
                                    onPointerUp={nextButtonTouch.handleTouchEnd}
                                    style={{
                                        width: "600px",
                                        height: "44px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        backgroundColor: "var(--point-color)",
                                        border: "white",
                                        color: "#fff",
                                        cursor: "pointer",
                                        borderRadius: '5px',
                                        padding: "0 10px"
                                    }}
                                    className={style.btn}
                                >
                                    <HorizontalFlex>
                                        <FlexChild justifyContent={"flex-end"}>
                                            <P font={"Pretendard"} weight={700} size={20} color={"white"}>다음</P>
                                        </FlexChild>
                                        <FlexChild width={"40%"} justifyContent={"flex-end"}>
                                            <img src={rightIcon} width={"10px"} style={{ filter: "invert(50%) brightness(250%)" }} />
                                        </FlexChild>
                                    </HorizontalFlex>
                                </div>
                            </div>
                            <FlexChild>
                                <VerticalFlex>
                                    <FlexChild height={"max-content"}>
                                        <Dummy height={"30px"} />
                                    </FlexChild>
                                    <FlexChild width={"93%"}>
                                        <HorizontalVendingProductLayout
                                            data={viewData.detailProduct}
                                            currentTab={currentTab}
                                            setCurrentTab={setCurrentTab}
                                            view={viewData.view}
                                            count={viewData.reviewCount}
                                        >
                                            {renderTabContent()}
                                        </HorizontalVendingProductLayout>
                                    </FlexChild>
                                </VerticalFlex>
                            </FlexChild>
                        </div>
                    </FlexChild>
                </VerticalFlex>
            </FlexChild>
        </HorizontalFlex>
    );
}

export default HorizontalProductDetail;